import React, { useEffect, useState } from "react";

import Logout from "../common/Logout";
import { getLocalData } from "../../../util/util";
import ReactTooltip from "react-tooltip";
import Modal from "./performancetracker";

//Authenticate Sales Header
const Header = (props) => {
  const [showperformance, handleshowperformance] = useState(false);
  return (
    <div className="dash_header_wrapper sales_wrapper">
      <div className="dash_header_left">
        <span>Welcome,</span>
        <span>
          {getLocalData("salesUserInfo")
            ? getLocalData("salesUserInfo").name
            : ""}
        </span>
        {props.grade && (
          <React.Fragment>
            <span
              data-tip
              data-for="registerTip"
              style={{
                display: "block",
                fontSize: "12px",
                marginTop: "3px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                handleshowperformance(!showperformance);
              }}
            >
              {getLocalData("salesUserInfo") && "Performance Grade :  "}
              {props.grade}
            </span>
            <ReactTooltip
              id="registerTip"
              place="bottom"
              type="success"
              effect="float"
              multiline={true}
            >
              <p> Previous month number of transactions : {props.totalCamp}</p>
              <p>
                {" "}
                Previous month campaign total value :{" "}
                {props.targetAmountAcheieved}
              </p>
            </ReactTooltip>
          </React.Fragment>
        )}
      </div>
      {showperformance && (
        <Modal
          isShowing={true}
          hide={handleshowperformance}
          silver={props.silver}
          gold={props.gold}
          targetAmountAcheieved={props.targetAmountAcheieved}
          totalCamp={props.totalCamp}
        />
      )}
      <Logout />
    </div>
  );
};
export default Header;



// WEBPACK FOOTER //
// ./web/components/salesUser/common/AuthHeader.jsx